import React from 'react';
import Input from '../../../components/ui/Input';
import Select from '../../../components/ui/Select';

const GoalConfigurationForm = ({ 
  selectedGoal, 
  formData, 
  onChange 
}) => {
  const timelineOptions = [
    { value: '3', label: '3 Months' },
    { value: '6', label: '6 Months' },
    { value: '12', label: '12 Months' },
    { value: '24', label: '24 Months' },
    { value: '36', label: '36 Months' }
  ];

  const renderRevenueFields = () => (
    <>
      <Input
        label="Target Revenue"
        type="number"
        placeholder="Enter target revenue in USD"
        value={formData?.targetRevenue}
        onChange={(e) => onChange('targetRevenue', e?.target?.value)}
        required
        description="Specify your revenue goal"
      />
      <Select
        label="Timeline"
        options={timelineOptions}
        value={formData?.timeline}
        onChange={(value) => onChange('timeline', value)}
        placeholder="Select timeline"
        required
      />
    </>
  );

  const renderProfitFields = () => (
    <>
      <Input
        label="Target Profit Margin (%)"
        type="number"
        placeholder="Enter target profit margin"
        value={formData?.profitMargin}
        onChange={(e) => onChange('profitMargin', e?.target?.value)}
        required
        min="0"
        max="100"
        description="Current to target profit margin improvement"
      />
      <Select
        label="Timeline"
        options={timelineOptions}
        value={formData?.timeline}
        onChange={(value) => onChange('timeline', value)}
        placeholder="Select timeline"
        required
      />
    </>
  );

  const renderExpansionFields = () => (
    <>
      <Input
        label="Growth Percentage (%)"
        type="number"
        placeholder="Enter expected growth percentage"
        value={formData?.growthPercentage}
        onChange={(e) => onChange('growthPercentage', e?.target?.value)}
        required
        min="0"
        description="Expected market expansion growth"
      />
      <Input
        label="Target Markets"
        type="text"
        placeholder="e.g., North America, Europe, Asia"
        value={formData?.targetMarkets}
        onChange={(e) => onChange('targetMarkets', e?.target?.value)}
        required
        description="Geographic or demographic markets"
      />
      <Select
        label="Timeline"
        options={timelineOptions}
        value={formData?.timeline}
        onChange={(value) => onChange('timeline', value)}
        placeholder="Select timeline"
        required
      />
    </>
  );

  const renderFundingFields = () => (
    <>
      <Input
        label="Funding Amount Required"
        type="number"
        placeholder="Enter funding amount in USD"
        value={formData?.fundingAmount}
        onChange={(e) => onChange('fundingAmount', e?.target?.value)}
        required
        description="Total capital needed"
      />
      <Input
        label="Use of Funds"
        type="text"
        placeholder="e.g., Product development, Marketing, Hiring"
        value={formData?.useOfFunds}
        onChange={(e) => onChange('useOfFunds', e?.target?.value)}
        required
        description="Primary allocation of raised capital"
      />
      <Select
        label="Timeline"
        options={timelineOptions}
        value={formData?.timeline}
        onChange={(value) => onChange('timeline', value)}
        placeholder="Select timeline"
        required
      />
    </>
  );

  const renderScalingFields = () => (
    <>
      <Input
        label="Target Team Size"
        type="number"
        placeholder="Enter target team size"
        value={formData?.teamSize}
        onChange={(e) => onChange('teamSize', e?.target?.value)}
        required
        description="Projected headcount after scaling"
      />
      <Input
        label="Infrastructure Investment"
        type="number"
        placeholder="Enter infrastructure budget in USD"
        value={formData?.infrastructure}
        onChange={(e) => onChange('infrastructure', e?.target?.value)}
        required
        description="Technology and operational infrastructure"
      />
      <Select
        label="Timeline"
        options={timelineOptions}
        value={formData?.timeline}
        onChange={(value) => onChange('timeline', value)}
        placeholder="Select timeline"
        required
      />
    </>
  );

  const renderFields = () => {
    switch (selectedGoal) {
      case 'revenue':
        return renderRevenueFields();
      case 'profit':
        return renderProfitFields();
      case 'expansion':
        return renderExpansionFields();
      case 'funding':
        return renderFundingFields();
      case 'scaling':
        return renderScalingFields();
      default:
        return null;
    }
  };

  return (
    <div className="space-y-4 md:space-y-6">
      {renderFields()}
    </div>
  );
};

export default GoalConfigurationForm;